var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegetablesPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998657 16C0.998657 19.9782 2.57901 23.7936 5.39206 26.6066C8.2051 29.4196 12.0204 31 15.9987 31C19.9769 31 23.7922 29.4196 26.6053 26.6066C29.4183 23.7936 30.9987 19.9782 30.9987 16C30.9987 12.0218 29.4183 8.20644 26.6053 5.3934C23.7922 2.58035 19.9769 1 15.9987 1C12.0204 1 8.2051 2.58035 5.39206 5.3934C2.57901 8.20644 0.998657 12.0218 0.998657 16V16Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6465 22.4677C19.983 23.1917 20.0367 24.0153 19.7971 24.7769C19.5574 25.5384 19.0417 26.1829 18.3513 26.5838C17.6608 26.9846 16.8454 27.1129 16.0653 26.9434C15.2851 26.7739 14.5964 26.3189 14.1345 25.6677L8.07988 16.601C7.92819 16.3738 7.82464 16.118 7.77563 15.8493C7.72661 15.5805 7.73316 15.3046 7.79488 15.0385C7.85659 14.7724 7.97216 14.5218 8.13446 14.3021C8.29676 14.0824 8.50235 13.8982 8.73855 13.761L11.9732 11.885C12.2093 11.7477 12.4711 11.6603 12.7423 11.6281C13.0135 11.5958 13.2884 11.6195 13.5501 11.6975C13.8118 11.7756 14.0548 11.9065 14.264 12.082C14.4732 12.2576 14.6442 12.4741 14.7665 12.7183L19.6465 22.4677Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2358 19.8332L13.3705 18.0118",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.356 12.825L5.75195 10.873",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3558 12.8252L10.9398 7.85852",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4987 9.06628C17.0274 8.16869 17.8854 7.51277 18.8902 7.23802C19.895 6.96326 20.9674 7.09135 21.8793 7.59504C22.7911 8.09874 23.4705 8.93829 23.7729 9.93515C24.0754 10.932 23.977 12.0075 23.4987 12.9329L16.4987 9.06628Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8907 12.048C21.2866 12.1408 20.7119 12.3708 20.2106 12.7203C19.7093 13.0697 19.2947 13.5294 18.9987 14.064L25.9987 17.9307C26.281 17.4204 26.4483 16.8545 26.4889 16.2728C26.5295 15.691 26.4424 15.1074 26.2337 14.5628C26.025 14.0183 25.6997 13.5259 25.2807 13.1203C24.8617 12.7147 24.359 12.4056 23.808 12.2147",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetablesPlate);
export default __webpack_public_path__ + "static/media/VegetablesPlate.02b61c8b56515cd1a7af2485836bcd37.svg";
export { ForwardRef as ReactComponent };